import { TaskStatus } from '@app/api/tasks';

export const TASKS_ROUTE = '/tools/tasks';

export const TASK_STATUS_LABELS: Record<TaskStatus, string> = {
  queued: 'В очереди',
  running: 'Выполняется',
  succeeded: 'Успешно',
  failed: 'Ошибка',
  canceling: 'Отменяется',
  canceled: 'Отменена',
};

export const TASK_STATUS_COLORS: Record<TaskStatus, string> = {
  queued: 'gray.500',
  running: 'blue.500',
  succeeded: 'green.500',
  failed: 'red.500',
  canceling: 'orange.500',
  canceled: 'gray.400',
};

export const TASK_STATUS_OPTIONS: EntityBase[] = (Object.keys(TASK_STATUS_LABELS) as TaskStatus[]).map((id) => ({
  id,
  name: TASK_STATUS_LABELS[id],
}));

/** Известные типы задач scheduler; неизвестные показываем как есть. */
export const TASK_TYPE_LABELS: Record<string, string> = {
  'sku.import': 'Импорт SKU',
  'outlet.routes': 'Импорт маршрутов ТТ',
};

export const TASK_TYPE_OPTIONS: EntityBase[] = Object.entries(TASK_TYPE_LABELS).map(([id, name]) => ({
  id,
  name,
}));

export const formatTaskType = (type?: string): string => (type ? TASK_TYPE_LABELS[type] || type : '—');

export const isCancellableStatus = (status?: TaskStatus): boolean => status === 'queued' || status === 'running';

export const isActiveStatus = (status?: TaskStatus): boolean =>
  status === 'queued' || status === 'running' || status === 'canceling';

export const formatProgress = (progress?: number): string => {
  if (progress == null || Number.isNaN(progress)) {
    return '—';
  }
  return `${Math.round(progress * 100)}%`;
};
